import React from 'react';
import { Grid, useMediaQuery, useTheme } from '@material-ui/core';

import { PeopleSlider } from './PeopleSlider';
import { Person } from './Person';
import { ContainerSection } from '../../../shared/components/ContainerSection';
import { Divider } from '../../../shared/components/Divider';
import { BOSS, COLLABORATORS, COORDINATORS } from './peopleData';

export const People = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <ContainerSection
      position={!matches ? 'left' : 'top'}
      anchor="persone"
      title="Persone"
    >
      <Grid container spacing={2} xs={12} item={true}>
        {BOSS.map(({ size, bio, image, name, job }, i) => (
          <Grid item xs={10} md={6} key={i}>
            <Person size={size} bio={bio} image={image} name={name} job={job} />
          </Grid>
        ))}
      </Grid>
      {!matches ? (
        <>
          <Divider height={30} />
          <Grid container spacing={2}>
            {COORDINATORS.map(({ size, bio, image, name, job }, i) => (
              <Grid item sm={3} key={i}>
                <Person
                  size={size}
                  bio={bio}
                  image={image}
                  name={name}
                  job={job}
                />
              </Grid>
            ))}
          </Grid>
          <Grid container spacing={2}>
            {COLLABORATORS.map(
              ({ size, bio, image, name, job, position }, i) => (
                <Grid item sm={3} key={i}>
                  <Person
                    size={size}
                    bio={bio}
                    image={image}
                    name={name}
                    job={job}
                    position={position}
                  />
                </Grid>
              )
            )}
          </Grid>
        </>
      ) : (
        <PeopleSlider />
      )}
    </ContainerSection>
  );
};
